import { render, staticRenderFns } from "./Dosimetrie.vue?vue&type=template&id=5aa23efe&"
import script from "./Dosimetrie.vue?vue&type=script&lang=js&"
export * from "./Dosimetrie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports